
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sourcing",
      function () {
        return require("private-next-pages/sourcing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sourcing"])
      });
    }
  